import { useLocalStorage } from 'usehooks-ts';
import z from 'zod';

const zAuth = z.object({
  access: z.string(),
  accessExpiresAt: z.preprocess(
    (s) => (typeof s == 'string' ? new Date(s) : undefined),
    z.date(),
  ),
  refresh: z.string(),
});

type Auth = z.infer<typeof zAuth>;

function parseAuth(value: string | undefined | null) {
  if (!value) return null;
  const auth = zAuth.safeParse(JSON.parse(value));
  if (!auth.success) return null;
  return auth.data;
}

export function setAuth(auth: Auth | null) {
  const oldValue = localStorage.getItem('credentials');
  let newValue: string | null;
  if (auth) {
    newValue = JSON.stringify(auth);
    localStorage.setItem('credentials', newValue);
  } else {
    newValue = null;
    localStorage.removeItem('credentials');
  }
  // Notify useLocalStorage hook
  window.dispatchEvent(
    new StorageEvent('local-storage', {
      key: 'credentials',
      oldValue,
      newValue,
    }),
  );
}

export function getAuth() {
  if (!global.localStorage) return null;

  return parseAuth(localStorage.getItem('credentials'));
}

export function useAuth() {
  const [auth] = useLocalStorage('credentials', getAuth, {
    deserializer: parseAuth,
    initializeWithValue: true,
  });

  return auth;
}
